import { FormBuilderOptions } from './types'

export const INPUT_SECTION_CLASS = 'input-section'
export const ERROR_MESSAGE_CLASS = 'error-message'

export const defaultOptions: FormBuilderOptions = {
  shouldUnregister: false,
  disableReadOnly: false,
}
